import { ARCHIVED_DATE, DELETED_DATE } from '../../common/constants.tsx';
import type { SortOrder } from '../../common/types.tsx';

export const PAGE_LIMIT = 25;
export const DEFAULT_SORT_KEY_ARCHIVED = ARCHIVED_DATE;
export const DEFAULT_SORT_KEY_DELETED = DELETED_DATE;
export const DEFAULT_SORT_ORDER: SortOrder = 'ASC';
